import { useSelector } from "react-redux";

import { usePageUpdatedActions } from "store/PageUpdatedSlice";

const usePageUpdated = (isNeededUpdating = false) => {
  const isUpdating = useSelector((state) => (isNeededUpdating ? state.PageUpdatedSlice.pageUpdated : false));
  const { changeValue, removeValue } = usePageUpdatedActions();

  return { changeValue, isUpdating, removeValue };
};

export default usePageUpdated;
